import { createModalContext } from "shared/components/vero-modal";

export const {
  Context: CancelDealModalContext,
  Provider: CancelDealModalProvider,
  useModalContext: useCancelDealModal,
} = createModalContext();
